import styled from 'styled-components';
import { useTheme } from '@mui/material';
import { ReactComponent as FolderClosedSolidIcon } from '../../assets/16x16/folder-solid.svg';
import { ReactComponent as FolderOpenedSolidIcon } from '../../assets/16x16/open-folder-solid.svg';
import { ReactComponent as FolderClosedOutlineIcon } from '../../assets/folder.svg';
import { ReactComponent as FolderOpenedOutlineIcon } from '../../assets/open-folder.svg';
import { componentToken } from '../../style/utils';

const SolidFolderClosed = styled(FolderClosedSolidIcon)`
  color: ${componentToken('treeView.folderIcon')};
`;

const SolidFolderOpened = styled(FolderOpenedSolidIcon)`
  color: ${componentToken('treeView.folderIcon')};
`;

// Looks with a folder icon color draw solid folders.
export const FolderClosedIcon = () => {
  const { folderIcon } = useTheme().tokens.components.treeView;

  return folderIcon ? <SolidFolderClosed /> : <FolderClosedOutlineIcon />;
};

export const FolderOpenedIcon = () => {
  const { folderIcon } = useTheme().tokens.components.treeView;

  return folderIcon ? <SolidFolderOpened /> : <FolderOpenedOutlineIcon />;
};
